export default __webpack_public_path__ + "static/media/elipsis-icon-gray.e69e50c8.svg";